export default "__VITE_ASSET__CycH9Otu__"